import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  SelectChangeEvent,
} from '@mui/material';
import ApiClient from '../../loopback/apiClient';
import { DigitalSurvey } from '../../redux/types';

const PREFIX = 'SurveySelector';

const classes = {
  selectorWidth: `${PREFIX}-selectorWidth`,
};

const StyledBox = styled(Box)(() => ({
  [`& .${classes.selectorWidth}`]: {
    width: 200,
  },
}));

type Props = {
  trialId: number;
  fetchFullDigitalSurvey: (surveyId: number) => void;
  fetchDigitalGroundTruth: (surveyId: number) => void;
}

const SurveySelector: React.FC<Props> = ({
  trialId,
  fetchFullDigitalSurvey,
  fetchDigitalGroundTruth,
}: Props) => {
  const [selected, setSelected] = useState<'survey'|'exercise'>('survey');

  useEffect(() => {
    ApiClient.getDigitalSurveyByTrialId(trialId)
      .then((digitalSurveys) => digitalSurveys.filter((ds) => (selected === 'survey' ? !ds.exercise : !!ds.exercise)))
      .then((selectedSurvey) => {
        let srvy: DigitalSurvey|Promise<DigitalSurvey>;
        [srvy] = selectedSurvey;
        if (!srvy) {
          srvy = ApiClient.createDigitalSurvey(
            {
              name: '',
              trialId,
              exercise: selected === 'exercise',
              passScore: 0,
            },
          );
        }
        return srvy;
      })
      .then((dgtlSurvey) => {
        fetchFullDigitalSurvey(dgtlSurvey.id);
        fetchDigitalGroundTruth(dgtlSurvey.id);
      });
  }, [trialId, selected, fetchFullDigitalSurvey, fetchDigitalGroundTruth]);

  const handleChange = (event: SelectChangeEvent<'survey' | 'exercise'>) => {
    const { value } = event.target;
    setSelected(value as 'survey'|'exercise');
  };

  return (
    <StyledBox>
      <FormControl className={classes.selectorWidth} size="small">
        <Select
          variant="outlined"
          labelId="survey-select"
          id="survey_select"
          value={selected}
          onChange={handleChange}
        >
          <MenuItem value="survey">Survey</MenuItem>
          <MenuItem value="exercise">Exercise</MenuItem>
        </Select>
      </FormControl>
    </StyledBox>
  );
};

export default SurveySelector;
